<template>
  <span>
    <span class="controls-ranked">
      <button
        type="button"
        class="btn up"
        :disabled="row.ranked_.isFirst"
        @click="$emit('handle', {type: 'rank', arrow: 'up', row: row})">
        <i class="fas fa-long-arrow-alt-up"></i>
      </button>
      <button
        type="button"
        class="btn down"
        :disabled="row.ranked_.isLast"
        @click="$emit('handle', {type: 'rank', arrow: 'down', row: row})">
        <i class="fas fa-long-arrow-alt-down"></i>
      </button>
    </span>
    {{row[col.field]}}
  </span>
</template>

<script>
export default {
  name: 'TemplateRank',
  props: {
    row: { type: Object, required: true },
    col: { type: Object, required: true },
    template: { type: Object, required: true }
  }
}
</script>
